module.exports = __webpack_public_path__ + "static/media/example-csv-file-cinelot.3014f9ae.csv";